import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import Icon from '@mui/material/Icon';
import {useStyles} from './style';

export default function EnlaceDeLista(props) {
    const { icon, primary, to, isNested } = props;
    const classes = useStyles();

    const renderLink = React.useMemo(
      () =>
        React.forwardRef((itemProps, ref) => (
          <RouterLink to={to} {...itemProps} innerRef={ref} />
        )),
      [to],
    );

    if (isNested){
      return (
        <div>
          <ListItem button component={renderLink}  className={classes.nested}>
            <Icon>{icon}</Icon>
            <ListItemText primary={primary} />
          </ListItem>
        </div>
      );
    }

    return (
      <div>
        <ListItem button component={renderLink}>
          <Icon>{icon}</Icon>
          <ListItemText primary={primary} />
        </ListItem>
      </div>
    );
  }